import React from 'react';
import loadablePackage from '@loadable/component';

import Skeleton from 'components/Skeleton';

export const loadableDefaultFallback = <Skeleton height="100vh" withSpinner />;

export const loadable = (importFn, { fallback = loadableDefaultFallback } = {}) =>
  loadablePackage(importFn, { fallback });
